import React, { ReactNode } from "react";

type TabItem = {
  label: ReactNode;
  disabled?: boolean;
  disabledReason?: string;
};

type TabsListProps = {
  tabs: TabItem[];
  activeIndex: number;
  onChange: (index: number) => void;
  className?: string;
};

export default function Tabs({
  activeIndex,
  children,
}: {
  activeIndex: number;
  children: React.ReactNode;
}) {
  return <>{React.Children.toArray(children)[activeIndex]}</>;
}

Tabs.Tab = function ({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
};

Tabs.List = function ({
  tabs,
  onChange,
  activeIndex,
  className = "",
}: TabsListProps) {
  return (
    <div className={`relative flex w-full border-b-2 ${className}`}>
      {tabs.map((tab, index) => {
        const isDisabled = tab.disabled;

        return (
          <button
            key={index}
            disabled={isDisabled}
            onClick={() => {
              if (!isDisabled) onChange(index);
            }}
            title={isDisabled ? tab.disabledReason : undefined}
            className={`
                relative z-10 py-1 px-2 text-center text-xs font-semibold flex-1
                focus:outline-none
                ${activeIndex === index ? "text-black" : "text-gray-600"}
                ${
                  isDisabled
                    ? "cursor-not-allowed text-gray-400"
                    : "hover:text-black"
                }
            `}
          >
            {tab.label}
          </button>
        );
      })}
      <div
        className="absolute -bottom-[1.5px] left-0 h-[2px] bg-black transition-all duration-300"
        style={{
          width: `${100 / tabs.length}%`,
          transform: `translateX(${activeIndex * 100}%)`,
        }}
      />
    </div>
  );
};
